export default __webpack_public_path__ + "static/media/icon-left.62006af7.svg";